/** Placeholder copy only — must never be persisted as `partnumber`. */
export const PART_NUMBER_PLACEHOLDER = "e.g. PRT-009";

export function sanitizeStoredPartNumber(
  raw: string | null | undefined,
): string {
  const t = String(raw ?? "").trim();
  if (!t) return "";
  if (/^e\.g\.?\s*/i.test(t)) return "";
  if (t.toLowerCase() === "e.g. prt-009") return "";
  return t;
}

/** Next `PRT-001` style code from existing rows (max numeric suffix + 1). */
export function suggestNextPartNumber(
  rows: { partnumber?: string | null }[],
): string {
  const n = rows.reduce((max, p) => {
    const cleaned = sanitizeStoredPartNumber(p.partnumber);
    const m = cleaned.match(/^PRT-(\d+)$/i);
    return m ? Math.max(max, parseInt(m[1], 10)) : max;
  }, 0);
  return `PRT-${String(n + 1).padStart(3, "0")}`;
}
